<template>
  <v-dialog dark :value="show" persistent max-width="500px" content-class="action-dialog-card">
    <v-card>
      <div class="dialog-header">
        <v-icon class="dialog-icon" color="var(--v-primary)">{{ icon }}</v-icon>
        <h2 class="dialog-title">{{ title }}</h2>
      </div>
      <v-card-text class="dialog-text">
        <p v-html="text"></p>
      </v-card-text>
      <v-card-actions class="dialog-actions">
        <v-btn text @click="onClose" class="close-button"> Schliessen </v-btn>
        <v-btn depressed :color="confirmButtonColor" @click="onConfirm" class="confirm-button">
          {{ confirmButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ActionDialog",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    confirmButtonText: {
      type: String,
      required: true,
    },
    confirmButtonColor: {
      type: String,
      default: "var(--v-primary)",
    },
    icon: {
      type: String,
      default: "mdi-lock-alert-outline",
    },
  },
  methods: {
    onClose() {
      this.$emit("close")
    },
    onConfirm() {
      this.$emit("confirm")
    },
  },
}
</script>

<style scoped>
.action-dialog-card {
  background: linear-gradient(145deg, #2a2a2a, #1a1a1a) !important;
  border-radius: 20px !important;
  border: 1px solid var(--border, #2c2c2c) !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5) !important;
  padding: 16px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  /* Definition der CSS-Variablen als Fallback */
  --v-primary: #ff0055;
  --text-primary: #ffffff;
  --text-secondary: #b0b0b0;
}

.dialog-header {
  text-align: center;
  padding: 24px 24px 16px 24px;
}

.dialog-icon {
  font-size: 4rem !important;
  margin-bottom: 16px;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
}

.dialog-text {
  color: var(--text-secondary);
  font-size: 1.1rem;
  text-align: center;
  line-height: 1.6;
  padding: 0 24px 24px 24px !important;
}

.dialog-actions {
  padding: 0 24px 24px 24px !important;
  display: flex;
  gap: 16px; /* Abstand zwischen den Buttons */
}

.close-button,
.confirm-button {
  flex: 1;
  border-radius: 12px;
  padding: 18px 0 !important;
  font-weight: 700;
  font-size: 1rem !important;
  letter-spacing: 0.5px;
  text-transform: none !important;
}

.close-button {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: var(--text-primary) !important;
}

.confirm-button {
  color: white !important;
}
</style>
